export default "__VITE_ASSET__BcDNT0ny__"